const ActionType = {
  SET_USER: 'SET_USER',
};

export default ActionType;
